<template>
  <img class="step-icon" :src="iconPath" alt="step icon" />
</template>

<script setup lang="ts">
import { computed } from "vue";

// The resulting image path is dynamic, so we use the static/content root
// which webpack copies wholesale into the output
const dayGraphicsRootPath = "/content/images/develop/day-graphics/";

function getIconPrefix(isCurrent, isAvailable): string {
  if (isCurrent) {
    return "P";
  }
  return isAvailable ? "G" : "B";
}

const props = withDefaults(
  defineProps<{
    dayOrPageType: string;
    isAvailable: boolean;
    isCurrent: boolean;
  }>(),
  {
    dayOrPageType: "",
    isAvailable: true,
    isCurrent: false,
  },
);

const iconPath = computed(() => {
  let icon = "page-type-error.png";

  const day = parseInt(props.dayOrPageType, 10);

  if (!Number.isNaN(day)) {
    const iconColourPrefix = getIconPrefix(props.isCurrent, props.isAvailable);
    icon = `${iconColourPrefix}${day}.svg`;
  }

  if (props.dayOrPageType === "journal") {
    icon = "journal-white.svg";
  }

  if (props.dayOrPageType === "library") {
    icon = "book-green.svg";
  }

  return dayGraphicsRootPath + icon;
});
</script>
